import React from "react";
import style from "./QuestCompound.module.scss";
import { StuTopics } from "service/homework";
import { QuestionType, getQuestionTypeName } from "service/service";
import QuestDanxuan from "../QuestDanxuan";
import QuestDuoxuan from "../QuestDuoxuan";
import QuestTianKong from "../QuestTianKong";
import QuestZhuguan from "../QuestZhuguan";
import { getCorrectState } from "../../utils";
import classNames from "classnames";

interface QuestCompoundProps {
    index: number;
    correct: boolean;
    trunk: string;
    topics: StuTopics[];
    onChange: (score: number, topicId: number, comment: string) => void;
}

export default function QuestCompound({
    index,
    correct,
    trunk,
    topics,
    onChange
}: QuestCompoundProps) {
    return (
        <div className={style.root}>
            <div className={classNames(style.content, "globalISROOTS")}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: `${index + 1}.${trunk}`
                    }}
                />
            </div>

            <div>
                {topics.map((topic, index) => (
                    <div key={topic.topicId}>
                        {topic.type === QuestionType.DanXuan && (
                            <div key={index} className={style.block}>
                                <div className={style.header}>
                                    <b>{getQuestionTypeName(topic.type)}</b>{" "}
                                    (本小题 {topic.score} 分)
                                </div>
                                <QuestDanxuan
                                    key={topic.topicId}
                                    index={index}
                                    trunk={topic.trunk}
                                    answers={topic.answers}
                                    correct={getCorrectState(topic, 1)}
                                />
                            </div>
                        )}
                        {topic.type === QuestionType.DuoXuan && (
                            <div key={index} className={style.block}>
                                <div className={style.header}>
                                    <b>{getQuestionTypeName(topic.type)}</b>{" "}
                                    (本小题 {topic.score} 分)
                                </div>
                                <QuestDuoxuan
                                    key={topic.topicId}
                                    index={index}
                                    trunk={topic.trunk}
                                    answers={topic.answers}
                                    correct={getCorrectState(topic, 1)}
                                />
                            </div>
                        )}
                        {topic.type === QuestionType.PanDuan && (
                            <div key={index} className={style.block}>
                                <div className={style.header}>
                                    <b>{getQuestionTypeName(topic.type)}</b>{" "}
                                    (本小题 {topic.score} 分)
                                </div>
                                <QuestDanxuan
                                    key={topic.topicId}
                                    index={index}
                                    trunk={topic.trunk}
                                    answers={topic.answers}
                                    correct={getCorrectState(topic, 1)}
                                />
                            </div>
                        )}
                        {topic.type === QuestionType.ZhuGuan && (
                            <div key={index} className={style.block}>
                                <QuestZhuguan
                                    comment={topic.comment}
                                    onChange={onChange}
                                    index={index}
                                    topicId={topic.topicId}
                                    contentText={topic.contentText}
                                    answers={topic.answers}
                                    trunk={`${index + 1}. ${topic.trunk}`}
                                    markScore={topic.markScore}
                                    score={topic.score}
                                />
                            </div>
                        )}

                        {topic.type === QuestionType.TianKong && (
                            <div key={index} className={style.block}>
                                <div className={style.header}>
                                    <b>{getQuestionTypeName(topic.type)}</b>{" "}
                                    (本小题 {topic.score} 分)
                                </div>
                                <QuestTianKong
                                    key={topic.topicId}
                                    index={index}
                                    trunk={topic.trunk}
                                    answers={topic.answers}
                                    correct={getCorrectState(topic, 1)}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
